// extracted by mini-css-extract-plugin
export default {"wrapper":"Admin_wrapper__hfl5f","content":"Admin_content__2m-AF","header":"Admin_header__vq6Lp","main-content":"Admin_main-content__TuJNg"};